var React = require('react');

function BigChevronRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"BigChevronRight","opacity":"0.3"},React.createElement("path",{"id":"ChevronRight","fillRule":"evenodd","clipRule":"evenodd","d":"M8.79289 3.29289C9.18342 2.90237 9.81658 2.90237 10.2071 3.29289L18.9142 12L10.2071 20.7071C9.81658 21.0976 9.18342 21.0976 8.79289 20.7071C8.40237 20.3166 8.40237 19.6834 8.79289 19.2929L16.0858 12L8.79289 4.70711C8.40237 4.31658 8.40237 3.68342 8.79289 3.29289Z","fill":"#E8EFFF"})));
}

BigChevronRight.defaultProps = {"width":"25","height":"24","viewBox":"0 0 25 24","fill":"none"};

module.exports = BigChevronRight;

BigChevronRight.default = BigChevronRight;
